const state = {
  blueprint: {
    show: false,
    btnAccept: 'controls.accept',
    btnDecline: 'controls.decline',
    title: null,
    text: null,
    execCallback: null,
    abortCallback: null
  },
  prompt: {
    show: false
  }
}

// getters
const getters = {
  getPrompt: state => {
    return state.prompt
  },
}

// actions
const actions = {
}

// mutations
const mutations = {
  newPrompt (state, prompt) {
    prompt.show = true
    state.prompt = Object.assign(state.blueprint, prompt);
  },

  closePrompt (state) {
    state.prompt.show = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
